import type { SVGProps } from 'react';
import * as React from 'react';
import { forwardRef, Ref } from 'react';

const SvgCopy = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 16 16"
    ref={ref}
    {...props}
  >
    <g clipPath="url(#copy_svg__a)">
      <path
        fill="currentColor"
        d="M8.867 5.2h-8.4A.467.467 0 0 0 0 5.667v8.4a.467.467 0 0 0 .467.466h8.4a.467.467 0 0 0 .466-.466v-8.4a.467.467 0 0 0-.466-.467M8.4 13.6H.933V6.133H8.4zm2.8-9.8v8.4a.467.467 0 0 1-.933 0V4.267H2.333a.467.467 0 0 1 0-.934h8.4a.467.467 0 0 1 .467.467"
      />
    </g>
    <defs>
      <clipPath id="copy_svg__a">
        <path fill="currentColor" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
const ForwardRef = forwardRef(SvgCopy);
export default ForwardRef;
